import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Box} from '@mui/material';
import {bool, func} from 'prop-types';

import MapPopperButton from '../map-popper-button.jsx';

export const VisibilityControl = ({onClick, isEditing, visible}) => (
  <Box
    sx={{
      transition: 'width 1s',
      width: isEditing ? 0 : 40,
      overflow: 'hidden',
      display: 'inline-block',
    }}
  >
    <MapPopperButton
      tooltip="Toggle visibility"
      tooltipPosition="top-end"
      onClick={onClick}
    >
      {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
    </MapPopperButton>
  </Box>
);

VisibilityControl.propTypes = {
  visible: bool,
  isEditing: bool,
  onClick: func,
};
